module.exports = __webpack_public_path__ + "media/images/noimage-user@3x-a8024a3d28df8f01746c5d7d3c4d3860.png";